import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import CategoryTable from "../../elements/Tables/CategoryTable/CategoryTable";
import CategoryCreationForm from "../../elements/Forms/CategoryCreationForm/CategoryCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_CATEGORY_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteCategory } from "../../../Services/CategoryService";

const { Search } = Input;

const CategoryPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryId, setCategoryId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setCategoryId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteCategory(categoryId);
      message.success("Category deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete category."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_CATEGORY_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Category
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <CategoryTable
        history={history}
        loading={loading}
        data={data}
        userData={userData}

        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Category"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <CategoryCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Category"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this category?</p>
      </Modal>
    </div>
  );
};

CategoryPage.propTypes = {};

export default CategoryPage;
